import { normalizeLocale } from "../translate.js";

/** @type {Record<string, string>} */
export const guideSketchesNl = {
  materialStock: "Materiaalvoorraad",
  materialMdfExample: "MDF 18 mm",
  materialMultiplex: "Multiplex",
  length: "Lengte",
  width: "Breedte",
  kerf: "Kerf",
  addOffcut: "+ Restmateriaal",
  subprojectExample: "Deelproject · Kast",
  examplePartLineSidePanel: "zijpaneel",
  panel: "Paneel",
  lengthByWidth: "L×B",
  quantityShort: "#",
  sidePanel: "Zijkant",
  shelf: "Plank",
  boardLayoutSheet1: "Zaagindeling · plaat 1",
  visualLayoutSheet1: "Visuele zaagindeling · plaat 1",
  result: "Resultaat",
  sheets: "platen",
  utilisation: "{{percent}}% benutting",
  brandName: "Plaatplan",
  import: "Importeren",
  exportMenu: "Exporteren ▾",
  exportWerkplanLabel: "Werkplan openen",
  exportWerkplanHint: "Zaaglijst, strategie, print als PDF",
  exportMaterialLabel: "Wat heb ik nodig",
  exportMaterialHint: "Inkoop",
  exportCsvLabel: "Zaaglijst (CSV)",
  exportCsvHint: "Spreadsheet",
  prepare: "Voorbereiden",
  shopOrder: "Zaagopdracht",
  werkplanStepsAriaLabel: "Werkplan stappen",
  whatToBring: "Wat neem je mee?",
  newStandardSheets: "Nieuwe standaardplaten",
  offcutMaterial: "Restmateriaal",
  cutStrategy: "Zaagstrategie",
  efficientCutting: "Efficiënt zagen",
  showCutLines: "Zaagsneden tonen",
  quantity: "Aantal",
  topPanel: "Bovenblad",
  checkCutSequence: "Zaagvolgorde controleren",
  viewSequence: "Volgorde bekijken",
  simulatorCollapsedHint: "Standaard dicht. Klik om stap voor stap te doorlopen.",
  cutSequenceTitle: "Zaagvolgorde · snede {{current}} van {{total}}",
  cutInstruction: "Snede {{current}}: Horizontale snede op 400 mm over volledige lengte",
  previous: "Vorige",
  next: "Volgende",
  keyboard: "Toetsenbord",
  keyArrowLeft: "←",
  keyArrowRight: "→",
  keyEscape: "Esc",
  keyboardLegendArrows: "vorige / volgende snede",
  keyboardLegendEscape: "simulator sluiten",
  shopOrderMaterial: "Zaagopdracht · MDF 18 mm",
  shopNote: "Graag zagen op onderstaande maten.",
  print: "Afdrukken",
  saveAsPdf: "Opslaan als PDF",
  cutListAndWerkplan: "Zaaglijst en werkplan",
};

/** @type {Record<string, string>} */
export const guideSketchesEn = {
  materialStock: "Material stock",
  materialMdfExample: "MDF 18 mm",
  materialMultiplex: "Plywood",
  length: "Length",
  width: "Width",
  kerf: "Kerf",
  addOffcut: "+ Offcut stock",
  subprojectExample: "Subproject · Cabinet",
  examplePartLineSidePanel: "side panel",
  panel: "Panel",
  lengthByWidth: "L×W",
  quantityShort: "#",
  sidePanel: "Side",
  shelf: "Shelf",
  boardLayoutSheet1: "Cut layout · sheet 1",
  visualLayoutSheet1: "Visual cut layout · sheet 1",
  result: "Result",
  sheets: "sheets",
  utilisation: "{{percent}}% utilisation",
  brandName: "Plaatplan",
  import: "Import",
  exportMenu: "Export ▾",
  exportWerkplanLabel: "Open work plan",
  exportWerkplanHint: "Cut list, strategy, print as PDF",
  exportMaterialLabel: "What do I need",
  exportMaterialHint: "Shopping list",
  exportCsvLabel: "Cut list (CSV)",
  exportCsvHint: "Spreadsheet",
  prepare: "Prepare",
  shopOrder: "Cut order",
  werkplanStepsAriaLabel: "Work plan steps",
  whatToBring: "What are you bringing?",
  newStandardSheets: "New standard sheets",
  offcutMaterial: "Offcut stock",
  cutStrategy: "Cut strategy",
  efficientCutting: "Efficient cutting",
  showCutLines: "Show cut lines",
  quantity: "Quantity",
  topPanel: "Top panel",
  checkCutSequence: "Check cut sequence",
  viewSequence: "View sequence",
  simulatorCollapsedHint: "Collapsed by default. Click to step through.",
  cutSequenceTitle: "Cut sequence · cut {{current}} of {{total}}",
  cutInstruction: "Cut {{current}}: Horizontal cut at 400 mm along full length",
  previous: "Previous",
  next: "Next",
  keyboard: "Keyboard",
  keyArrowLeft: "←",
  keyArrowRight: "→",
  keyEscape: "Esc",
  keyboardLegendArrows: "previous / next cut",
  keyboardLegendEscape: "close simulator",
  shopOrderMaterial: "Cut order · MDF 18 mm",
  shopNote: "Please cut to the dimensions below.",
  print: "Print",
  saveAsPdf: "Save as PDF",
  cutListAndWerkplan: "Cut list and work plan",
};

/** @type {Record<string, Record<string, string>>} */
const SKETCHES_BY_LOCALE = {
  nl: guideSketchesNl,
  en: guideSketchesEn,
};

/**
 * @param {string | undefined} locale
 * @returns {Record<string, string>}
 */
export function buildGuideSketches(locale) {
  const normalized = normalizeLocale(locale);
  return SKETCHES_BY_LOCALE[normalized] ?? guideSketchesNl;
}
